<template>
    <el-breadcrumb v-if="type==1" separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item v-for="(item,index) in pageHeaderList" :key="'pageHeader'+index">
            <router-link :to="item.path?{ path: item.path }:''" targe="_blank">{{item.name}}</router-link></el-breadcrumb-item>
    </el-breadcrumb>

    <el-page-header v-else @back="goBack" :content="pageHeader"></el-page-header>
</template>
<script>
export default {
    props:{
        type:{
            type:Number,
            required:false,
            default:1
        },
        pageHeaderList:{
            type: Array,
            required:false
        },
        pageHeader:{
            type: String,
            required:false
        }
    },
    data(){
        return{

        }
    },
    methods: {
      goBack() {
        this.$router.go(-1)
      }
    }
}
</script>
<style lang="scss" scoped>
.el-breadcrumb{
    line-height: 20px;
    margin: 15px 0;
}
</style>


// WEBPACK FOOTER //
// src/components/assembly/back.vue